
<div class="back_login">
    
    <div fxLayout="row" fxLayoutAlign="center">

        <div fxFlex.xl="30" fxFlex.lg="40" fxFlex.md="50" fxFlex.sm="70" fxFlex.xs="90" >

            <mat-card class="login-card">
                <mat-card-header>
                  <mat-card-title>
                      <div fxLayout="row">
                        <div fxFlex="100" class="left">
                          <img class="logo" src="assets/static/logo_auslroma1.png" />
                        </div>
                      </div>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-actions  align="center">
                        <button mat-button color="primary" (click)="login()">LOGIN</button>
                </mat-card-actions>
              </mat-card>

            </div>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </div>

</div>
